var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"music-detail-container"},[_vm._m(0),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('music-list',{attrs:{"list":_vm.similarList,"isSimilar":false}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('p',[_vm._v("相似音乐推荐")]),_c('span',[_vm._v("SIMILAR MUSIC")])])
}]

export { render, staticRenderFns }